<template>
  <div
    class="infinity-toggle"
    :class="{
      'infinity-toggle--active': value,
    }"
    @click="$emit('handleToggle')"
  >
    <div class="infinity-toggle__circle"></div>
    <span class="material-icons">all_inclusive</span>
  </div>
</template>

<script>
  export default {
    name: 'InfinityToggle',
    props: ['value'],
  };
</script>

<style scoped>
  .infinity-toggle {
    width: 58px;
    height: 28px;
    background-color: rgba(181, 181, 201, 1);
    border-radius: 999px;
    display: flex;
    align-items: center;
    cursor: pointer;
    position: relative;
    transition: background-color 0.3s;
  }

  .infinity-toggle--active {
    background-color: rgba(147, 147, 236, 1);
  }

  .infinity-toggle__circle {
    width: 24px;
    height: 24px;
    background-color: rgba(53, 53, 72, 1);
    border-radius: 50%;
    position: absolute;
    left: 2px;
    top: 2px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: transform 0.3s;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
  }

  .infinity-toggle--active .infinity-toggle__circle {
    transform: translateX(30px);
    background-color: #ffffff;
  }

  .material-icons {
    position: absolute;
    top: 2px;
    right: 3px;
    font-size: 24px;
    color: rgba(53, 53, 72, 1);
    transition: transform 0.3s;
  }

  .infinity-toggle--active .material-icons {
    transform: translateX(-27px);
  }
</style>
